import slugify from "slugify";

/**
 * String utilities
 * -----------------------------------------------------------------------------
 */

export const makeSlug = (str: string) => {
  return slugify(str, { remove: /[*+~.()'"!:@,?]/g })?.toLowerCase();
};

export function trimString(input: string | null, trimLength: number = 25) {
  if (!input || input.length <= trimLength) return input;
  return input.substring(0, trimLength) + "...";
}

export function stripHtml(html: string | null | undefined): string {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "");
}
